<ng-container [ngSwitch]="dastNode.type">
    <div *ngSwitchCase="'root'">
        <lib-dast-renderer *ngFor="let child of dastNode.children" [dastNode]="child"></lib-dast-renderer>
    </div>
    <ul *ngSwitchCase="'list'">
        <lib-dast-renderer *ngFor="let child of dastNode.children" [dastNode]="child"></lib-dast-renderer>
    </ul>
    <li *ngSwitchCase="'listItem'">
        <lib-dast-renderer *ngFor="let child of dastNode.children" [dastNode]="child"></lib-dast-renderer>
    </li>
    <p *ngSwitchCase="'paragraph'">
        <lib-dast-renderer *ngFor="let child of dastNode.children" [dastNode]="child"></lib-dast-renderer>
    </p>
    <a *ngSwitchCase="'link'" [href]="dastNode.href">{{ dastNode.content }}</a>
    <span *ngSwitchCase="'span'">{{ dastNode.value }}</span>
    <div *ngSwitchDefault>Unsupported type: {{ dastNode.type }}</div>
</ng-container>
